module.exports = __webpack_public_path__ + "img/leg-right-front.75f5675c.png";